<section class="has-padding-block-1 animated fadeIn" >
  <h2 class="section-title">Increasing Access to Local Food</h2>
  <div class="row">
    <div class="col-sm-5">
     <img src="assets/images/landing/increasing-access-to-local-food/access-to-local-food.webp"  class="img-side is-height-3" alt="Increasing Access to Local Food">
    </div>
    <div class="col-sm-7">
      <p><strong>When you shop at Philly Foodworks, you're not just buying groceries.</strong></p>
      <p>You're an active participant in building a food system that supports local farmers, nourishes
        families, and fosters sustainability.</p>
      <p>Want to help even more? Consider making a one-time or recurring tax-deductible donation, which will
        go toward the food access initiatives detailed below.</p>
        <p>Any questions about our food access work or your donations? Email <a href="mailto:info&#64;phillyfoodworks.com">info&#64;phillyfoodworks.com</a></p>
      <p>Want to help even more? Consider adding a one-time or recurring tax-deductible donation on your shopping cart when you check out. This will support the food access initiatives detailed below.</p>
      <div class="btn-wrap is-center">
      </div>
    </div>
  </div>
</section>
<hr class="is-thick">

<div class="banner-title-wrap is-center mb-5">
  <div class="banner-title is-multi-line is-primary">
    <p>You are more than a customer – you are a partner!</p>
  </div>
</div>

<div>
  <h2 class="section-title">How we help increase food access to those in need</h2>
  <div class="ul-icon-list">
    <span class="list-icon material-symbols-outlined">grocery</span>
    <div class="list-content">
      <h3 class="list-title">Low-cost produce boxes</h3>
      <p>Our Low-Cost Produce boxes allow organizations and community groups to save money and increase their impact by purchasing produce in bulk. Your donations help offset the administrative costs of this program allowing us to only charge organizations for the direct costs. This creates a scalable impact opportunity.</p>
    </div>
  </div>
  <div class="ul-icon-list">
    <span class="list-icon material-symbols-outlined">agriculture</span>
    <div class="list-content">
      <h3 class="list-title">Neighborhood farmstand</h3>
      <p>Our farmstand is located in front of our warehouse at 20th and Hunting Park on Fridays from 11am - 3pm. Our warehouse is located in North Philadelphia amidst a designated food desert. We accept SNAP payments and offer high-quality locally sourced food at a discount for our neighbors who otherwise do not have access to this food. Neighbors shop, participate in workshops, and share knowledge about health and food. Your donations subsidize the cost of the food and help pay for staffing and coordination of the market.</p>
    </div>
  </div>
  <div class="ul-icon-list">
    <span class="list-icon material-symbols-outlined">redeem</span>
    <div class="list-content">
      <h3 class="list-title">Weekly Food Donations</h3>
      <p>No good food goes to waste. Our surplus fruits and vegetables find their way to organizations like West Phillie Produce, Sunday Love Project, Social Impact Cafe, and community fridges. In addition to donating surplus fruits and vegetables, we buy additional items from local farms and producers and donate them to these organizations. Your donations help us support local farmers while providing high quality food for free to those in need.</p>
    </div>
  </div>
</div>
